import React from 'react';
import confetti from 'canvas-confetti';
import './teamdev.css';

export const fmtDate = (iso) => {
  if (!iso) return '';
  try { return new Date(iso).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }); } catch { return ''; }
};

export const rise = (i) => ({ animationDelay: `${Math.min(i, 10) * 60}ms` });

export function fireConfetti() {
  const colors = ['#34d399', '#fbbf24', '#38bdf8', '#f472b6', '#a78bfa'];
  confetti({ particleCount: 90, spread: 70, origin: { y: 0.65 }, colors });
  setTimeout(() => confetti({ particleCount: 50, spread: 100, origin: { y: 0.6 }, colors }), 250);
}

export function Avatar({ name, className = '' }) {
  return (
    <span className={`w-6 h-6 rounded-full bg-emerald-600/20 flex items-center justify-center text-[10px] font-bold font-mono text-emerald-400 shrink-0 ${className}`}>
      {name?.charAt(0)?.toUpperCase() || '?'}
    </span>
  );
}

export function Help({ children }) {
  return <p className="text-[11px] text-muted-foreground/90 mt-1.5 leading-relaxed">{children}</p>;
}

export function SbiBlock({ label, text, color }) {
  if (!text) return null;
  return (
    <div className="mt-2.5">
      <p className={`text-[9px] font-mono uppercase tracking-wider ${color}`}>{label}</p>
      <p className="text-sm text-foreground/90 whitespace-pre-wrap mt-0.5 leading-relaxed">{text}</p>
    </div>
  );
}

export const SKILL_STYLE = {
  hard: 'border-sky-500/40 bg-sky-500/10 text-sky-400',
  soft: 'border-emerald-500/40 bg-emerald-500/10 text-emerald-400',
};
export const SKILL_LABEL = { hard: 'Hard Skill', soft: 'Soft Skill' };

export const TREND_STYLE = {
  progress: 'bg-emerald-400',
  no_opportunity: 'bg-zinc-500',
  setback: 'bg-amber-400',
};
export const TREND_LABEL = {
  progress: 'Fortschritt gemacht',
  no_opportunity: 'Keine Gelegenheit',
  setback: 'War schwieriger',
};

export const wordCount = (s) => (s || '').trim().split(/\s+/).filter(Boolean).length;
